import React, { Component } from "react";
import RootChangeUsername from "container/account/changeUsername/RootChangeUsername";
import GatewayCheckpoint from "container/common/GatewayCheckpoint";
import AppUpdateCheckpoint from "container/common/AppUpdateCheckpoint";
import { getEssentialUrl } from "lib/urlQueryParser";

class ChangeUsernamePage extends Component {
  render() {
    return (
      <AppUpdateCheckpoint>
        <GatewayCheckpoint
          type={"replace"}
          url={getEssentialUrl({ type: "opening" })()}
        >
          <RootChangeUsername />
        </GatewayCheckpoint>
      </AppUpdateCheckpoint>
    );
  }
}

export default ChangeUsernamePage;
